import { get } from 'lodash'
import { COUNTRY_SHORTCODES } from '../../constants'

const defaultFallbackApplicantCountry = COUNTRY_SHORTCODES.US

const isCitizenOfApplicationCountry = application => {
  const citizenshipCountryShortname = get(
    application,
    'citizenshipCountryShortname',
    defaultFallbackApplicantCountry
  )
  const country = get(application, 'country', defaultFallbackApplicantCountry)
  const isCitizen = citizenshipCountryShortname === country

  return isCitizen
}

export default isCitizenOfApplicationCountry
